<app-dc-alert-inner></app-dc-alert-inner>
<ng-container *ngIf="loading">
  <app-dc-pane
    [noScroll]="true"
    [loading]="loading"
    [noHeader]="true"
  ></app-dc-pane>
</ng-container>

<div class="container" *ngIf="!results.length && !loading; else resultsTempRef">
  <div class="no-results">
    <img
      src="assets/request-analytics.svg"
      class="requestIcon"
      alt="Request Governance Checks Icon"
    />

    <div class="no-results__label">No test results available</div>

    <button
      class="btn btn-primary requestButton"
      (click)="runTests()"
      [disabled]="disableRequestButton"
    >
      Run Tests
    </button>
  </div>
</div>

<ng-template #resultsTempRef>
  <div class="results-container" *ngIf="!loading">
    <div class="results-container__sidebar">
      Test executions
      <app-dc-pane
        class="results-table"
        [noHeader]="true"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="false"
      >
        <app-dc-table
          [columns]="testExecutionColumns"
          [rows]="results"
          [sort]="[{ prop: 'createdAt', dir: 'desc' }]"
          [messages]="messages"
          [showFooter]="false"
          [selected]="selectedTest"
          [selectedRow]="true"
          (select)="onRowClicked($event)"
          [rowHeight]="40"
        ></app-dc-table>
      </app-dc-pane>
    </div>
    <div class="results-container__main">
      <div class="hidden-label">Results</div>
      <app-dc-pane
        [lightBackground]="true"
        class="results-pane"
        [noScroll]="false"
      >
        <ng-container class="heading">
          <div class="results-details">
            <div class="results-details__row">
              <div class="results-details__label">Results as of date:</div>
              <div class="results-details__value">
                <strong
                  >{{ selectedTest?.[0].asOfDate | date: 'dd/MM/YYYY' }}</strong
                >
              </div>
            </div>
            <div
              class="results-details__row"
              *ngIf="selectedTest?.[0]?.benchmark"
            >
              <div class="results-details__label">
                Value for money hurdle rate:
              </div>
              <div class="results-details__value">
                <strong
                  >{{ selectedTest?.[0]?.benchmark | roundAndFormat : '2'
                  }}%</strong
                >
              </div>
            </div>
            <div class="results-details__row">
              <div class="results-details__label">Retrieved at:</div>
              <div class="results-details__value">
                <strong
                  >{{ selectedTest?.[0].reportRetrievedAt | date: 'dd/MM/YYYY HH:mm' }}</strong
                >
              </div>
            </div>
            <div class="results-details__row">
              <div class="results-details__label">Analytics service:</div>
              <div class="results-details__value">
                <strong>{{ selectedTest?.[0].source }}</strong>
              </div>
            </div>
            <div class="results-details__row">
              <div class="results-details__label">Overall Result:</div>
              <div
                class="results-details__value"
                [title]="selectedTest?.[0].overallResult"
              >
                <strong
                  >{{ selectedTest?.[0]?.overallResult?.toUpperCase() }}</strong
                >
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container class="headingAction">
          <button
            class="btn btn-outline-primary btn-sm mr-2"
            (click)="downloadReport()"
            *restrictTo="'VIEW_ANALYTICS_REPORT'"
          >
            Download Report
          </button>
        </ng-container>

        <ng-container *ngIf="selectedTest?.[0].results.length; else noResults">
          <app-governance-test-results
            *ngFor="let result of selectedTest?.[0].results"
            [test]="result"
          >
          </app-governance-test-results>
        </ng-container>

        <ng-template #noResults>
          <div class="no-results">
            <img
              src="assets/request-analytics.svg"
              class="requestIcon"
              alt="Request Governance Checks Icon"
            />

            <div class="no-results__label">
              This test execution didn't run any tests. No results available.
            </div>
          </div>
        </ng-template>
      </app-dc-pane>
    </div>
  </div>
</ng-template>
